import { render } from "./accountcreated.vue?vue&type=template&id=09795b21"
const script = {}

import exportComponent from "D:\\Projects\\GhanaWaterHelpCenter\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__